import "../../styles/section6.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChild,
  faGraduationCap,
  faPalette,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import OwnDrawingBtn from "./OwnDrawingBtn";
import { FadeAnimate, FadeBottomAnimate } from "../../components/animateEffect/Fade";

const usersData = [
  {
    icon: faChild,
    title: "Kids",
    description: "Practice school projects or creative assignments easily.",
  },
  {
    icon: faGraduationCap,
    title: "Students",
    description: "Practice school projects or creative assignments easily.",
  },
  {
    icon: faPalette,
    title: "Hobby Artists",
    description: "Explore new styles and improve their artwork without frustration.",
  },
  {
    icon: faBriefcase,
    title: "Professional Artists",
    description: "Create quick outlines, accurate designs, and achieve consistent results every time.",
  },
];

const Section6 = () => {
  return (
    <div className="section6Container" id="ForEveryone">
      <div className="container sectionVerticalSpace">
        <div className="row justify-content-center sectionTitleBS">
          <div className="col-lg-9 text-center">
            <FadeAnimate>
              <h2 className="header-title">AR Drawing for Everyone: Kids to Professionals</h2>
              <p className="flyer-description mb-0">
                The AR Drawing app works for all ages and skill levels. From kids learning shapes to professionals creating precise outlines, everyone benefits.
              </p>
            </FadeAnimate>
          </div>
        </div>
        <div className="row feature-row">
          {usersData.map((user, index) => (
            <FadeBottomAnimate key={index}>
              <div className="col-md-6 col-lg-3 feature-col mb-4 mb-md-2">
                <div className="feature-item text-center d-flex flex-column">
                  <FontAwesomeIcon icon={user.icon} className="feature-icon" />
                  <h5>{user.title}</h5>
                  <p>{user.description}</p>
                </div>
              </div>
            </FadeBottomAnimate>
          ))}
        </div>
        <OwnDrawingBtn title="Learn & Draw with AR Drawing" />
      </div>
    </div>
  );
};

export default Section6;
